import { injectable } from 'inversify';
import { injectToken, Token } from 'inversify-token';
import { YinzCamAPI, YinzCamAPIRequest, YinzCamAPIRequestComponent, YinzCamAPIToken, YinzCamServer } from 'yinzcam-api';


export const YinzCamCardsServerV2Token = new Token<YinzCamCardsServerV2>(Symbol.for("YinzCamCardsServerV2Token"));

const HEADERS_WITH_LANG = { 'X-YinzCam-Static-API-Use-Environment': 'true', 'X-YinzCam-Static-API-Use-Language': 'true' };
const HEADERS_NO_LANG = { 'X-YinzCam-Static-API-Use-Environment': 'true', 'X-YinzCam-Static-API-Use-Language': 'false' }
const BASE_REQ = { addEnvironmentParams: true };
const BASE_REQ_WITH_LANG = { ...BASE_REQ, headers: HEADERS_WITH_LANG };
const BASE_REQ_NO_LANG = { ...BASE_REQ, headers: HEADERS_NO_LANG };

@injectable()
export class YinzCamCardsServerV2 {
  private readonly server: YinzCamServer;

  public constructor(@injectToken(YinzCamAPIToken) private readonly api: YinzCamAPI) {
    this.server = api.getServer('pages');
  }

  public getRequest(request: YinzCamAPIRequest) {
    return this.server.getRequest(request);
  }

  public getPage(id: string): YinzCamAPIRequestComponent {
    return this.server.getRequest({ ...BASE_REQ_WITH_LANG, path: `pages/${id}` });
  }

  public getFragment(id: string): YinzCamAPIRequestComponent {
    return this.server.getRequest({ ...BASE_REQ_WITH_LANG, path: `fragments/${id}` });
  }

  public getMessages(id: string): YinzCamAPIRequestComponent {
    return this.server.getRequest({ ...BASE_REQ_NO_LANG, path: `messages/${id}` });
  }

  public getMenu(id: string): YinzCamAPIRequestComponent {
    return this.server.getRequest({ ...BASE_REQ_WITH_LANG, path: `menus/${id}` });
  }

  public getStyle(id: string): YinzCamAPIRequestComponent {
    return this.server.getRequest({ ...BASE_REQ_NO_LANG,path: `styles/${id}` });
  }

  /*public getConfiguration(id: string): YinzCamAPIRequestComponent {
    return this.server.getRequest({ ...BASE_REQ_NO_LANG, path: `configurations/${id}` });
  }*/
}